/**
 * 区分 betaFeatureType（roles.beta_features の要素）
 * 出典：旧PCRM の config/beta-features.ts・backend shared/beta-features.ts（274：10/14 ユーザー判断で旧と同じ構造で戻す）。
 * 旧と同じく、選んで保存するだけで、どの機能の判定にも使っていない（旧でも効いていなかった）。
 * 値は旧の id（advanced_reports 等）を新CRM の命名規則（小文字キャメル）にしたもの。並び・名前・説明・分類・開発状況は旧のまま
 */
export const BETA_FEATURE_TYPE_VALUES = ['advancedReports', 'aiSuggestions', 'bulkOperations', 'calendarSync'] as const;

export type BetaFeatureType = (typeof BETA_FEATURE_TYPE_VALUES)[number];

export const BETA_FEATURE_TYPE_LABELS: Readonly<Record<BetaFeatureType, string>> = {
  advancedReports: '高度なレポート',
  aiSuggestions: 'AI提案',
  bulkOperations: '一括操作',
  calendarSync: 'カレンダー連携',
};

export const BETA_FEATURE_DESCRIPTIONS: Readonly<Record<BetaFeatureType, string>> = {
  advancedReports: 'カスタムレポートテンプレートとダッシュボード分析',
  aiSuggestions: 'AIによる次のアクション提案',
  bulkOperations: '企業・取引の一括更新・削除',
  calendarSync: '外部カレンダーとの同期機能',
};

/** 旧の分類（画面の小見出し：分析・AI・操作・連携） */
export const BETA_FEATURE_CATEGORY_LABELS: Readonly<Record<BetaFeatureType, string>> = {
  advancedReports: '分析',
  aiSuggestions: 'AI',
  bulkOperations: '操作',
  calendarSync: '連携',
};

/** 旧の開発状況の札（alpha・beta・rc） */
export const BETA_FEATURE_STAGES: Readonly<Record<BetaFeatureType, 'alpha' | 'beta' | 'rc'>> = {
  advancedReports: 'beta',
  aiSuggestions: 'alpha',
  bulkOperations: 'beta',
  calendarSync: 'rc',
};
